import React from 'react';
import { FaBolt, FaShieldAlt, FaHeadset, FaSync } from 'react-icons/fa';
import './Features.css';

function Features() {
  const features = [
    {
      icon: <FaBolt />,
      title: 'Instant Delivery',
      description: 'Get your key in under 30 seconds. No waiting, no hassle.'
    },
    {
      icon: <FaShieldAlt />,
      title: 'Built-In Spoofer',
      description: 'HWID spoofer included with every purchase. Stay protected.'
    },
    {
      icon: <FaHeadset />,
      title: '24/7 Support',
      description: "Got questions? We're here around the clock on Discord."
    },
    {
      icon: <FaSync />,
      title: 'Free Updates',
      description: 'All updates included. No hidden fees or surprise charges.'
    }
  ];

  return (
    <section className="section features" id="features">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Why Choose RiftOne</h2>
          <p className="section-subtitle">Built for gamers who want results, not excuses</p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card card">
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Features;
